import chessHorse from '../../../images/puzzles/theMachine/chessHorse.png'
import chessPawn from '../../../images/puzzles/theMachine/chessPawn.png'
import chessRook from '../../../images/puzzles/theMachine/chessRook.png'
import chessBishop from '../../../images/puzzles/theMachine/chessBishop.png'

const machineSettingsData = {
    maxTime: 180, //in secs
    overheatMaxCountdown: 10, //in secs
    winningPhase: 3,
    buttonLabels: ['Fourth', 'First', 'Second', 'Third'],
    lightCombos: [
        [
            0, 0, 0,
            0, 0, 0,
            0, 0, 0,
            0, 0, 0
        ],
        [
            0, 0, 0,
            0, 1, 1,
            1, 1, 1,
            0, 1, 0
        ],
        [
            1, 1, 1,
            1, 0, 1,
            1, 0, 1,
            1, 1, 1
        ],
        [
            0, 1, 1,
            0, 1, 1,
            1, 0, 0,
            0, 1, 0
        ],
        [
            1, 0, 0,
            1, 1, 1,
            1, 1, 0,
            1, 1, 0
        ],
        [
            0, 1, 0,
            1, 1, 1,
            1, 0, 1,
            1, 1, 0
        ]
    ],
    errorCodeData: [
        {
            name: 'C-32-P9',
            answer: [
                ['243', 'ay', 'first', '100001'],
                ['243', 'ay', 'third', '110011']
            ],
            switchImg: chessHorse,
            switchIcon: ['fas fa-random', 'fas fa-exchange-alt'],
            lightIndex: [4, 3]
        },
        {
            name: 'V3NU5',
            answer: [
                ['421', 'ya', 'first', '110100'], 
                ['421', 'ya', 'fourth', '011001']
            ],
            switchImg: chessRook,
            switchIcon: ['fas fa-random', 'fas fa-exchange-alt'],
            lightIndex: [1, 2]
        },
        {
            name: '4Z2-8',
            answer: [
                ['313', 'xy', 'fourth', '010101'],
                ['313', 'xy', 'first', '010101']
            ],
            switchImg: chessPawn,
            switchIcon: ['fas fa-random', 'fas fa-exchange-alt'],
            lightIndex: [2, 4]
        },
        {
            name: '5T3-V3NIC',
            answer: [
                ['421', 'by', 'third', '110100'], 
                ['421', 'by', 'first', '011001']
            ],
            switchImg: chessRook,
            switchIcon: ['fas fa-random', 'fas fa-exchange-alt'],
            lightIndex: [3, 1]
        },
        {
            name: 'H4RT-N3TT',
            answer: [
                ['243', 'ba', 'second', '111000'],
                ['243', 'ba', 'first', '111000']
            ],
            switchImg: chessBishop,
            switchIcon: ['fas fa-random', 'fas fa-exchange-alt'],
            lightIndex: [5, 4]
        },
        {
            name: '8L-284',
            answer: [
                ['313', 'xb', 'second', '100001'], 
                ['313', 'xb', 'third', '110011']
            ],
            switchImg: chessHorse,
            switchIcon: ['fas fa-random', 'fas fa-exchange-alt'],
            lightIndex: [5, 3]
        }
    ] 
}

export default machineSettingsData
